//import ButtonWithIcon from "@/components/UI-Kit/ButtonWithIcon";
import { CardContent, Typography } from "@mui/material";
// import ArrowRightIcon from "@/assets/icons/arrow-long-right.svg?react";
// import { ROUTES } from "@/utils/navigation";

interface IProps {
  description: string;
  title: string;
}

const Description: React.FC<IProps> = ({ description }) => {
  return (
    <CardContent sx={{ padding: "0 !important" }} >
      <Typography
        variant="body1"
        mb={{ xs: 0.5, md: 2.5 }}
        maxWidth="360px"
        color="text.secondary"
      >
        {description}
      </Typography>
      {/* <ButtonWithIcon
        label="Learn More"
        IconComponent={ArrowRightIcon}
        isLink={true}
        to={`${ROUTES.features}/${title.toLowerCase()}`}
      /> */}
    </CardContent>
  );
};

export default Description;
